import { createFileRoute, Link, Navigate } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";
import { useSessao } from "@/hooks/useAuth";
import { buttonVariants } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export const Route = createFileRoute("/")({ component: Landing });

const destaques = [
  {
    eyebrow: "Governança",
    title: "Aprovação por alçada",
    body: "Até R$ 5.000 uma aprovação, até R$ 10.000 duas, acima disso três. As faixas são configuráveis, e cada aprovação fica identificada e datada.",
  },
  {
    eyebrow: "Estrutura",
    title: "Quem paga ≠ quem se beneficia",
    body: "A holding paga, o resultado vai para a empresa beneficiada e a obrigação intercompany nasce sozinha. O consolidado do grupo elimina o saldo.",
  },
  {
    eyebrow: "Rastro",
    title: "Nada se apaga",
    body: "Lançamento aprovado se estorna, e o estorno aponta para o original. A trilha de auditoria não aceita escrita de ninguém — nem de administrador.",
  },
];

function Landing() {
  const { estado } = useSessao();
  if (estado === "liberado") return <Navigate to="/painel" />;

  return (
    <main className="min-h-dvh bg-background">
      <div className="mx-auto max-w-5xl px-6 py-16 md:py-24">
        <div className="flex items-center gap-2.5">
          <span className="font-display flex size-8 items-center justify-center rounded-full bg-emerald text-base text-background">
            P
          </span>
          <span className="font-display text-xl">Parker</span>
          <span className="label-caps ml-1">Lonepine</span>
        </div>

        <h1 className="font-display mt-16 max-w-3xl text-[2.75rem] leading-[1.05] md:mt-20 md:text-[4.5rem]">
          O controle gerencial da Lonepine, em um só lugar.
        </h1>
        <p className="mt-6 max-w-2xl text-base text-muted-foreground md:text-lg">
          Receitas, despesas, compras e contratos das empresas do grupo — com aprovação por valor,
          conciliação bancária e visão consolidada sem dupla contagem.
        </p>

        <div className="mt-10">
          <Link to="/auth" className={cn(buttonVariants({ size: "lg" }))}>
            Entrar no Parker <ArrowRight className="size-4" />
          </Link>
        </div>

        <hr className="rule-horizon mt-20" />

        {/* A grade cujas calhas são as linhas: cada bloco tem fundo opaco, que é
            o que recorta o fio. */}
        <div className="mt-px grid gap-px bg-hairline md:grid-cols-3">
          {destaques.map((f) => (
            <div key={f.title} className="bg-background px-1 py-8 md:px-6">
              <p className="label-caps">{f.eyebrow}</p>
              <h2 className="font-display mt-3 text-xl">{f.title}</h2>
              <p className="mt-3 text-sm text-muted-foreground">{f.body}</p>
            </div>
          ))}
        </div>

        <p className="mt-16 max-w-2xl text-xs text-muted-foreground">
          O Parker é a visão gerencial do grupo. Não substitui a contabilidade fiscal — serve de
          base de conciliação com o financeiro e a contabilidade.
        </p>
      </div>
    </main>
  );
}
